import {BoardObject} from '../components/board-object.js';

export class PopData {
    obj: BoardObject;
    row: number;
    col: number;
    delay: number;
    distance: number;
    constructor(
        objIn: BoardObject,
        rowIn: number,
        colIn: number,
        delayIn: number,
        distanceIn: number
    ) {
        this.obj = objIn;
        this.row = rowIn;
        this.col = colIn;
        this.delay = delayIn;
        this.distance = distanceIn;
    }
}
